
    var riot = require('riot')
    //src: starling/src/tags/presence.html
riot.tag2('presence',
  '<div if="{!window.pageSettings.hideUsers && presenceCount()}" ref="users" class="users mrgn-l-8"> <ul if="{presenceCount() < 4}" class="presence-avatar_list"> <li each="{value in getSortedCollaborators()}" id="presence-avatar-{value.id || value.visitorId}" class="presence-avatar" data-id="{value.id || value.visitorId}" data-tip="{value.display_name}" riot-style="--color: {colorFromUserId(value.id)};" onclick="{panToCursor}" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseOut}"> <img class="avatar presence-avatar_image" riot-src="{value.avatar_url || \'/images/avatar.png\'}" alt="{value.display_name} avatar"> </li> </ul> <div if="{presenceCount() >= 4}" class="presence-dropdown large-collab-list"> <button ref="dropdownToggleButton" onclick="{toggleDropdown}" data-tip="{getCollaboratorsTooltip()}" class="Button Button--Plain Button--Header"> <svg class="Button__Icon"> <use xlink:href="#people-icon"></use> </svg> <span class="Button__Label"> {presenceCount() - getStalePresences().length}/{presenceCount()} </span> </button> <div ref="dropdownContainer" id="presence-dropdown-container" class="presence-dropdown_container hidden"> <header class="presence-dropdown_header"> You have {presenceCount()} collaborators </header> <ul class="presence-dropdown_list" onwheel="{handleScroll}"> <li each="{value in getSortedCollaborators()}" id="presence-list-{value.id || value.visitorId}" class="presence-dropdown_item" data-id="{value.id || value.visitorId}" riot-style="border-color: {colorFromUserId(value.id)};" onclick="{panToCursor}" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseOut}"> <div class="presence-dropdown_item_avatar"> <img class="avatar presence-dropdown_item_avatar_image" riot-src="{value.avatar_url || \'/images/avatar.png\'}" alt="{value.display_name} avatar"> </div> <span class="presence-dropdown_item_title">{value.display_name}</span> </li> </ul> </div> </div> <div each="{value in presence}" id="presence-{value.id || value.visitorId}" class="user top-avatar labelled {value.visitorId ? \'anonymous\' : \'\'} large-collab-list" data-id="{value.id || value.visitorId}" riot-style="color: {colorFromUserId(value.id)}; border-bottom-color: {colorFromUserId(value.id)}; background-image: url({value.avatar_url || \'/images/avatar.png\'});" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseOut}"> <label>{value.display_name}</label> </div> </div>',
  '',
  'class="presence {\'logged-out\': window.user} hideWhenPresenting"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _nodesUi = require('lib/nodes-ui');

var _collaboratorsUi = require('lib/collaborators-ui');

var _opts = opts,
    canvas = _opts.canvas,
    operation = _opts.operation;

this.canvas = canvas;
this.operation = operation;
this.colorFromUserId = _util.colorFromUserId;
this.presence = {};

this.userNodes = {};
this.canvas.presence = this;
this.hoveredUserId = null;

this.presenceCount = function () {
  return Object.values(_this.presence).length;
};

this.getCollaboratorsTooltip = function () {
  return _this.presenceCount() + ' collaborators';
};

this.isStale = function (presence) {
  return !presence || Date.now() - presence.last_seen > 8000;
};

this.getSortedCollaborators = function () {
  return Object.values(_this.presence).sort(function (a, b) {
    var isStaleA = _this.isStale(a);
    var isStaleB = _this.isStale(b);

    if (isStaleA && !isStaleB) return 1;
    if (isStaleB && !isStaleA) return -1;

    var nameA = a.display_name.toLowerCase();
    var nameB = b.display_name.toLowerCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
};

this.canvas.on('mount', function () {

  // highlight nodes newly created by other folks.
  _this.operation.on('operation-add-node', function (message) {
    var nodeTag = _this.canvas.nodeTags[message.node.id];
    // when a collaborator creates a new card, it'll be outlined in their color for a few seconds
    if (nodeTag) {
      nodeTag.setLocalBorderHighlightColor((0, _util.colorFromUserId)(message.node.createdById));
      _nodesUi.nui.highlightCardBorders(nodeTag.instance);
      window.setTimeout(function () {
        _nodesUi.nui.unhighlightCardBorders(nodeTag.instance);
        nodeTag.unsetLocalBorderHighlightColor();
      }, 5000);
    }
  });

  _this.operation.on('operation-add-link', function (message) {
    var linkTag = _this.canvas.linkTags[message.link.id];
    // when a collaborator creates a new card, it'll be outlined in their color for a few seconds
    if (linkTag) {
      linkTag.setLocalBorderHighlightColor((0, _util.colorFromUserId)(message.link.createdById));
      linkTag.setPresenceHovered();
      window.setTimeout(function () {
        linkTag.unsetPresenceHovered();
        linkTag.unsetLocalBorderHighlightColor();
      }, 5000);
    }
  });

  _this.handleMouseEnter = function (e) {
    if (!e.target.id) return;
    var userId = e.target.getAttribute('data-id');
    if (!userId) return;
    if (_this.hoveredUserId && _this.hoveredUserId === userId) return;
    _this.hoveredUserId = userId;
    var color = (0, _util.colorFromUserId)(userId);

    _this.canvas.refs.canvas.style.setProperty('--card-border-highlight-color', color);
    document.body.classList.add('user-presence-active');

    for (var id in _this.canvas.nodeTags) {
      var nodeTag = _this.canvas.nodeTags[id];
      if (nodeTag.instance.createdById == userId) {
        nodeTag.setPresenceHovered();
        _nodesUi.nui.highlightCardBorders(nodeTag.instance);
      }
    }

    /*
      show card that user is focused on too
    */
    var focus = _collaboratorsUi.cui.getCollaboratorFocus({ userId: userId });
    if (focus && focus.nodeId) {
      var _nodeTag = _this.canvas.nodeTags[focus.nodeId];
      if (_nodeTag) {
        _nodeTag.setPresenceHovered();
        _nodesUi.nui.highlightCardBorders(_nodeTag.instance);
      }
    }

    for (var _id in _this.canvas.linkTags) {
      var linkTag = _this.canvas.linkTags[_id];
      if (linkTag.instance.createdById == userId) {
        linkTag.setPresenceHovered();
      }
    }
  };

  _this.handleMouseOut = function (e) {
    _this.hoveredUserId = null;
    $('.user-presence-highlight').removeClass('user-presence-highlight');
    $('.parent-of-user-presence-highlight').removeClass('parent-of-user-presence-highlight');
    _nodesUi.nui.unhighlightAllCardBorders();
    _this.canvas.refs.canvas.style.removeProperty('--card-border-highlight-color');
    document.body.classList.remove('user-presence-active');
  };

  _this.isMenuClosed = function () {
    var dropdownContainer = _this.refs.dropdownContainer;

    return dropdownContainer && dropdownContainer.classList.contains('hidden');
  };

  _this.openMenu = function () {
    var _refs = _this.refs,
        dropdownContainer = _refs.dropdownContainer,
        dropdownToggleButton = _refs.dropdownToggleButton;

    dropdownContainer && dropdownContainer.classList.remove('hidden');
    dropdownToggleButton && dropdownToggleButton.setAttribute('data-tip-hide', 'true');
    _this.menuOpen = true;
  };

  _this.hideMenu = function () {
    var _refs2 = _this.refs,
        dropdownContainer = _refs2.dropdownContainer,
        dropdownToggleButton = _refs2.dropdownToggleButton;

    dropdownContainer && dropdownContainer.classList.add('hidden');
    _this.menuOpen = false;
    dropdownToggleButton && dropdownToggleButton.removeAttribute('data-tip-hide');
  };

  _this.toggleDropdown = function (e) {
    var isClosed = _this.isMenuClosed();

    e.stopPropagation();
    _this.canvas.hidePopups();

    if (isClosed) {
      _this.openMenu();
    }
  };

  _this.setPresence = function (user) {
    _this.presence[user.id || user.visitorId] = user;
    _this.sawPresence(user.id || user.visitorId);
    canvas.tags['presence-cursors'].update();
  };

  _this.getPresence = function (userId) {
    return _this.presence[userId];
  };

  _this.sawPresence = function (id) {
    _this.presence[id].last_seen = Date.now();
    _collaboratorsUi.cui.setPresent(id);
    var presenceEl = _this.root.querySelector('#presence-' + id);
    if (presenceEl) {
      presenceEl.style.opacity = 1;
    }
    var presenceListEl = _this.root.querySelector('#presence-list-' + id);
    if (presenceListEl) {
      presenceListEl.classList.add('presence-dropdown_item--active');
    }
    var presenceAvatarEl = _this.root.querySelector('#presence-avatar-' + id);
    if (presenceAvatarEl) {
      presenceAvatarEl.classList.add('presence-avatar--active');
    }
  };

  _this.getStalePresences = function () {
    return Object.values(_this.presence).filter(_this.isStale);
  };

  if (window.map_collaborators && window.map_collaborators.length) {
    for (var _iterator = window.map_collaborators, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var collab = _ref;

      if (collab.user.id != window.user_id) {
        _this.setPresence(collab.user);
      }
    }
    _this.update();
  }

  _this.operation.sender.setHandler('presence', function (_ref2) {
    var user = _ref2.user,
        focus = _ref2.focus;

    if (!_this.getPresence(user.id || user.visitorId)) {
      _this.setPresence(user);
      _this.update();
    }
    _collaboratorsUi.cui.updateCollaboratorFocusDisplay({ user: user, focus: focus });

    _this.sawPresence(user.id || user.visitorId);
  });

  window.setInterval(function () {
    if (_this.operation.isLoggedOut() || !(0, _util.getCookieValue)('visitor')) {
      return;
    }

    _collaboratorsUi.cui.sendPresence();

    _this.getStalePresences().forEach(function (presence) {
      if (presence.id) {
        var presenceEl = _this.root.querySelector('#presence-' + presence.id);
        if (presenceEl) {
          presenceEl.style.opacity = 0.4;
        }
        var presenceListEl = _this.root.querySelector('#presence-list-' + presence.id);
        if (presenceListEl) {
          presenceListEl.classList.remove('presence-dropdown_item--active');
        }
        var presenceAvatarEl = _this.root.querySelector('#presence-avatar-' + presence.id);
        if (presenceAvatarEl) {
          presenceAvatarEl.classList.remove('presence-avatar--active');
        }
        _collaboratorsUi.cui.unsetPresent(presence.id);
      } else if (presence.visitorId) {
        var _presenceEl = _this.root.querySelector('#presence-' + presence.visitorId);
        delete _this.presence[presence.visitorId];
        canvas.tags['presence-cursors'].update();
      }

      _this.update();
    });
  }, 2000);
});

this.handleScroll = function (event) {
  return event.stopPropagation();
};

this.panToCursor = function (event) {
  var id = event.currentTarget.getAttribute('data-id');

  if (_this.isStale(_this.getPresence(id))) return;

  var focus = _collaboratorsUi.cui.getCollaboratorFocus({ userId: id });
  if (focus) {
    _this.canvas.centerContent({
      nodes: focus.nodeId ? [canvas.store.getNode(focus.nodeId)] : [],
      regions: focus.regionId ? [canvas.store.getRegion(focus.regionId)] : []
    });
    return;
  }

  var cursor = canvas.tags['presence-cursors'].root.querySelector('#cursor-' + id);
  if (!cursor) return;

  var _cursor$getBoundingCl = cursor.getBoundingClientRect(),
      right = _cursor$getBoundingCl.right,
      bottom = _cursor$getBoundingCl.bottom,
      left = _cursor$getBoundingCl.left,
      top = _cursor$getBoundingCl.top;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var et = top - ty;
  var el = left - tx;
  var eb = bottom - ty;
  var er = right - tx;

  var extents = [et, el, eb, er].map(function (number) {
    return Math.round((number - 8 * (1 - scale)) / scale);
  });

  event.stopPropagation();

  canvas.panZoomTo(extents, null, { animate: true });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('presence')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/presence.html
// module id = 611
// module chunks = 0